
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/vouchers/voucher-terms",
      function () {
        return require("private-next-pages/[lang]/vouchers/voucher-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/vouchers/voucher-terms"])
      });
    }
  